export default {"src":"/spot-fe-premarket/_next/static/media/4.7b5502df.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};